function Ressources() {
    this.build();
}

Ressources.prototype.build = function () {
    const modalForm = document.querySelector('#formModal');
    if( !modalForm ){
        return;
    }

    const downloads = document.querySelectorAll('[data-js-form-ressource]');
    const myModal = new bootstrap.Modal('#formModal',{
        keyboard: false,
        backdrop: 'static'
    });

    downloads.forEach( (download) => {
        const url = download.href;
        download.addEventListener( "click", (e) => {
            if( url.indexOf(".pdf") < 0 ) {
                e.preventDefault();
                let fileID = download.dataset.file;
                let input = document.querySelector('.ressource-form input[name="file"]');
                input.value = fileID;
                let forceDownload = document.querySelectorAll('.force-download');
                forceDownload.forEach( (link) => {
                    link.href = download.dataset.link;
                });
                myModal.show();

                $('#formModal').on('shown.bs.modal', function (e) {
                    let close = document.querySelector('.modal .btn-close');
                    close.addEventListener('click', (e) => {
                        if( modalForm.querySelector('.wpcf7').classList.contains('success') ) {
                            window.location.reload();
                        } else {
                            myModal.hide();
                        }
                    });
                });
            }
        });

    });
};


